"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifCli = void 0;
var flApi = require("./flApi");
var NotifCli = (function () {
    function NotifCli() {
        var _this = this;
        this.notifHandler = function (msg) {
            var e_1, _a;
            var newNotifs = [];
            try {
                if (msg.type !== "data" || ["flmain", "flmain_service"].indexOf(msg.dbName) > -1) {
                    return newNotifs;
                }
                if (msg.dbName.toLowerCase() !== _this.restApi.getDBName().toLowerCase()) {
                    return newNotifs;
                }
                switch (msg.eCN) {
                    case 90:
                        if (msg.eCN === 90) {
                            msg.data.forEach(function (aData) {
                                switch (msg.operation) {
                                    case "i":
                                    case "u":
                                        _this.curListField.set(aData.id, aData);
                                        break;
                                    case "d":
                                        _this.curListField.delete(aData.id);
                                        break;
                                }
                            });
                        }
                        return newNotifs;
                    case 0:
                        var dicoEntObj = void 0;
                        var dicoFiObj = void 0;
                        try {
                            for (var _b = __values(msg.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var oneMsgData = _c.value;
                                var bUpdated = false;
                                var oneData = oneMsgData.j === undefined ?
                                    oneMsgData :
                                    oneMsgData.j;
                                switch (oneData.c2) {
                                    case "E":
                                        if (msg.operation !== "i") {
                                            dicoEntObj = flApi.Api.getInstance().entities.getByEcn(oneData.id);
                                            if (dicoEntObj === null) {
                                                msg.operation = msg.operation === "d" ? "d" : "i";
                                            }
                                            else {
                                                switch (msg.operation) {
                                                    case "u":
                                                        dicoEntObj.encode(oneData);
                                                        dicoEntObj.postProcess();
                                                        bUpdated = true;
                                                        break;
                                                    case "d":
                                                        if (dicoEntObj !== null && dicoEntObj !== undefined) {
                                                            flApi.Api.getInstance().entities.removeEntityOrField(oneData.id);
                                                        }
                                                        bUpdated = true;
                                                        break;
                                                    default:
                                                        console.log("*** Notification Error: invalid code operation!! msg=" + JSON.stringify(msg));
                                                        continue;
                                                }
                                            }
                                        }
                                        if (msg.operation === "i") {
                                            dicoEntObj = flApi.Api.getInstance().entities.getByEcn(oneData.id);
                                            if (dicoEntObj === null || dicoEntObj === undefined) {
                                                dicoEntObj = new flApi.EntityClass(oneData);
                                                flApi.Api.getInstance().entities.addItem(dicoEntObj);
                                                bUpdated = true;
                                            }
                                        }
                                        break;
                                    case "F":
                                        var oneDataField = oneData;
                                        var bSendUIRemoteNotification = false;
                                        var myEnt = flApi.Api.getInstance().entities.getByEcn(oneDataField.c1);
                                        if (myEnt === null) {
                                            console.log("*** Notification Error: Field operation with no entity... " +
                                                JSON.stringify(oneDataField));
                                            continue;
                                        }
                                        if (msg.operation === "i") {
                                            if (myEnt.getField(oneDataField.id) === null) {
                                                switch (oneDataField.c7) {
                                                    case "string":
                                                        dicoFiObj = new flApi.FieldString("string", oneDataField);
                                                        break;
                                                    case "number":
                                                        dicoFiObj = new flApi.FieldNumber("number", oneDataField);
                                                        break;
                                                    case "rollup":
                                                        dicoFiObj = new flApi.FieldRollup("rollup", oneDataField);
                                                        break;
                                                    case "uid":
                                                        dicoFiObj = new flApi.FieldUserId("uid", oneDataField);
                                                        myEnt.hasUid = true;
                                                        break;
                                                    case "linkedField":
                                                        dicoFiObj = new flApi.FieldLinkedField("linkedField", oneDataField);
                                                        break;
                                                    case "json":
                                                        dicoFiObj = new flApi.FieldJson("json", oneDataField);
                                                        break;
                                                    case "freejson":
                                                        dicoFiObj = new flApi.FieldFreejson("freejson", oneDataField);
                                                        break;
                                                    case "pointer":
                                                        dicoFiObj = new flApi.FieldPointer("pointer", oneDataField);
                                                        break;
                                                    default:
                                                        console.log("*** Notification Error: invalid systemType: " +
                                                            JSON.stringify(oneDataField));
                                                        continue;
                                                }
                                                dicoFiObj.postProcess();
                                                myEnt.fields.push(dicoFiObj);
                                                bUpdated = true;
                                            }
                                        }
                                        else {
                                            dicoFiObj = myEnt.getField(oneDataField.id);
                                            switch (msg.operation) {
                                                case "u":
                                                    if (dicoFiObj === null) {
                                                        console.log("*** Notification Error: unknown Entity " +
                                                            JSON.stringify(oneDataField));
                                                        continue;
                                                    }
                                                    dicoFiObj.encode(oneDataField);
                                                    dicoFiObj.postProcess();
                                                    bUpdated = true;
                                                    break;
                                                case "d":
                                                    if (dicoFiObj !== null) {
                                                        flApi.Api.getInstance().entities.removeEntityOrField(myEnt.id, oneDataField.id);
                                                        bUpdated = true;
                                                    }
                                                    break;
                                                default:
                                                    console.log("*** Notification Error: invalid code operation!! msg=" +
                                                        JSON.stringify(msg));
                                                    continue;
                                            }
                                            if (oneDataField.c7 === "pointer" &&
                                                oneDataField.c21[1].c22 !== myEnt.id) {
                                                bSendUIRemoteNotification = true;
                                            }
                                        }
                                        if (bSendUIRemoteNotification) {
                                            bSendUIRemoteNotification = false;
                                        }
                                        break;
                                    default:
                                        if (Object.keys(oneData).length > 0) {
                                            console.log("*** Notification Error: Bad notification received: " +
                                                JSON.stringify(oneData) + ", keys: " + Object.keys(oneData).length);
                                        }
                                        continue;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        break;
                    default:
                        return newNotifs;
                }
                return newNotifs;
            }
            catch (err) {
                console.log("Error in notif handler: " + err.stack);
                return [];
            }
        };
    }
    NotifCli.prototype.inject = function (curListServer, restApi) {
        this.curListField = curListServer;
        this.restApi = restApi;
        this.restApi.addNotificationHandler("notificationManager", this.notifHandler, 1);
    };
    return NotifCli;
}());
exports.NotifCli = NotifCli;
